/* IN2THEX — Cursor, Scroll Reveal, Preloader */
(function () {
  var isTouch = window.matchMedia('(hover: none)').matches;


  /* ── CUSTOM CURSOR ── */
  (function () {
    if (isTouch) return;
    var dot  = document.getElementById('in2-cursor-dot');
    var ring = document.getElementById('in2-cursor-ring');
    if (!dot || !ring) return;

    var mx = -100, my = -100;
    var rx = -100, ry = -100;
    var rafId;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate(' + (mx - 4) + 'px,' + (my - 4) + 'px)';
    });

    function animRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.transform = 'translate(' + (rx - 18) + 'px,' + (ry - 18) + 'px)';
      rafId = requestAnimationFrame(animRing);
    }
    animRing();

    var hoverTargets = 'a,button,[data-cursor-hover],img,.in2-pdp__thumb,.in2-na__item,.in2-drop__item,.in2-lb__item';
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest(hoverTargets)) {
        dot.classList.add('is-hover');
        ring.classList.add('is-hover');
      }
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest(hoverTargets)) {
        dot.classList.remove('is-hover');
        ring.classList.remove('is-hover');
      }
    });
    document.addEventListener('mouseleave', function () {
      dot.style.opacity = '0'; ring.style.opacity = '0';
    });
    document.addEventListener('mouseenter', function () {
      dot.style.opacity = '1'; ring.style.opacity = '1';
    });
  })();

  /* ── SCROLL REVEAL ── */
  (function () {
    var selectors = [
      '.in2-sh__left','.in2-sh__right',
      '.in2-na__item','.in2-na__header',
      '.in2-drop__left','.in2-drop__right',
      '.in2-mf__left','.in2-mf__right',
      '.in2-nl__headline','.in2-nl__form','.in2-nl__bottom',
      '.in2-dc__content',
      '.in2-ugc__header',
      '.in2-pr__inner',
      '.in2-cd__left','.in2-cd__right',
      '.in2-ds__header','.in2-ds__card',
      '.in2-lb__item',
      '.in2-val__item',
      '.in2-cs__left','.in2-cs__right',
      '.in2-hsp__panel',
      '.in2-mq',
      '.in2-rv__item',
    ].join(',');

    var els = document.querySelectorAll(selectors);
    if (!els.length) return;

    els.forEach(function (el, i) {
      el.classList.add('in2-reveal');
      el.style.transitionDelay = (i % 4) * 0.07 + 's';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in2-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    els.forEach(function (el) { io.observe(el); });
  })();

})();
